module.exports = __webpack_public_path__ + "static/img/9.b1ccd29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/9.png
// module id = aTZx
// module chunks = 0